import {
  SET_GROUP_ORDER_DATA,
  SET_GROUP_ORDER_CART_DATA,
  SET_INTERVAL_GROUP_ORDER_DATA,
  ADD_GROUP_ORDER_GOODS,
  SUB_GROUP_ORDER_GOODS,
  SET_FREE_SHIPPING_PROGRESS
} from './actions';
import { IGroupOrderCart, IGroupOrderData, IIntervalGroupOrderData, UserItemsProducts } from '@/types/mkpl-group-order';
import { getUniqueId2Qty } from '@/utils/common/product-card';
import isEqual from '@/utils/isEqual';
export interface IState {
  groupOrderData?: IGroupOrderData;
  groupOrderCartData?: IGroupOrderCart;
  id2qty?: Record<string, number>;
  intervalGroupOrderData?: IIntervalGroupOrderData;
  canCheckout: boolean;
  freeShippingTag: {
    type: string;
    tag: string;
    progressBarType: string;
    shipping_free_progress: number;
    diff_price: number;
    vendor_name: string;
    recommendProductList: any;
    is_turn: number;
    turn_url: any;
    product_image_url: any;
  };
  groupOrderInvalid: boolean;
}

export const initialState: IState = {
  groupOrderData: null,
  groupOrderCartData: null,
  intervalGroupOrderData: null,
  id2qty: {},
  canCheckout: false,
  freeShippingTag: null,
  groupOrderInvalid: false
};

export const reducer = (state: IState = initialState, action: any) => {
  const { groupOrderCartData, canCheckout, id2qty, intervalGroupOrderData } = state;
  switch (action.type) {
    case SET_INTERVAL_GROUP_ORDER_DATA:
      //对比前后的数据如果数据一致则不更新, 减少渲染
      const newData = action.payload;
      //拼团无效
      if (newData?.invalid) {
        return {
          ...state,
          groupOrderInvalid: true
        };
      }
      if (intervalGroupOrderData && newData) {
        if (JSON.stringify(intervalGroupOrderData) !== JSON.stringify(newData)) {
          return {
            ...state,
            intervalGroupOrderData: action.payload
          };
        }
        return state;
      }
      return {
        ...state,
        intervalGroupOrderData: action.payload
      };
    case SET_GROUP_ORDER_DATA:
      return {
        ...state,
        groupOrderData: action.payload
      };
    case SET_GROUP_ORDER_CART_DATA:
      //对比前后的数据如果数据一致则不更新, 减少渲染

      const newCartData = action.payload;

      //除了团长之外的所有人的购物车状态都是confirmed, 则可以结算
      const newCanCheckout = newCartData?.items
        ?.filter(item => !item.is_owner)
        .every(item => item?.adding_status === 'confirmed');

      if (isEqual(groupOrderCartData, newCartData) && canCheckout === newCanCheckout) {
        return state;
      }

      //从items中过滤当前用户的购物车数据, 然后转化为id2qty存储
      const { items } = newCartData || {};
      let newId2qty: Record<string, number> = {};
      if (items && items.length > 0) {
        items.forEach(item => {
          const userId = item.user_id;
          const userItems = item?.items || [];
          userItems.forEach(userItem => {
            newId2qty[getUniqueId2Qty(userId, userItem.product_id)] = userItem.quantity;
          });
        });
      }
      return {
        ...state,
        canCheckout: newCanCheckout,
        id2qty: newId2qty,
        groupOrderCartData: action.payload
      };
    case ADD_GROUP_ORDER_GOODS:
      const addProduct = action.payload;
      return {
        ...state,
        id2qty: {
          ...id2qty,
          [getUniqueId2Qty(addProduct.user_id, addProduct.product_id)]: addProduct?.quantity
        }
      };
    case SUB_GROUP_ORDER_GOODS:
      const subProduct = action.payload;
      const subUserId2qty = getUniqueId2Qty(subProduct.user_id, subProduct.product_id);
      const isDelete = state.id2qty.hasOwnProperty(subUserId2qty) && subProduct.quantity === 0;
      const subId2qty = { ...state.id2qty };

      if (isDelete) {
        delete subId2qty[subUserId2qty];
      } else {
        subId2qty[subUserId2qty] = subProduct?.quantity;
      }
      return {
        ...state,
        id2qty: subId2qty
      };
    case SET_FREE_SHIPPING_PROGRESS:
      return {
        ...state,
        freeShippingTag: action.payload
      };
    default:
      return state;
  }
};
